import React from 'react'
import { useDevTools } from 'global/context/sub-contexts/devToolsContext'

import * as styles from './DevToolsBadge.module.scss'

const DevToolsBadge = () => {
  const { customCssDisabled, setCustomCssDisabled } = useDevTools()

  if (!customCssDisabled) return null

  return (
    <button
      type="button"
      className={styles.badge}
      onClick={() => setCustomCssDisabled(false)}
      aria-label="Custom CSS is disabled. Click to re-enable."
    >
      <span className={styles.dot} />
      Custom CSS OFF
      <span className={styles.hint}>click to restore</span>
    </button>
  )
}

export default DevToolsBadge
